var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_jmU6gJPRW1WlOQoEba07zrqlcdTfbnop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_jmU6gJPRW1WlOQoEba07zrqlcdTfbnop)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 17.50000000000003,
    cy: 17.5,
    r: 17.5,
    fill: "#0265F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 23.929 18.571 L 18.571 18.571 L 18.571 23.929 C 18.571 24.518 18.089 25 17.5 25 C 16.911 25 16.429 24.518 16.429 23.929 L 16.429 18.571 L 11.071 18.571 C 10.482 18.571 10 18.089 10 17.5 C 10 16.911 10.482 16.429 11.071 16.429 L 16.429 16.429 L 16.429 11.071 C 16.429 10.482 16.911 10 17.5 10 C 18.089 10 18.571 10.482 18.571 11.071 L 18.571 16.429 L 23.929 16.429 C 24.518 16.429 25 16.911 25 17.5 C 25 18.089 24.518 18.571 23.929 18.571 Z ",
    fill: "rgb(255,255,255)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.5684fa421a81dc7f351da3fb526c55b5.svg";
export { ForwardRef as ReactComponent };